import React, { useState, Fragment } from "react";
import {
	useTable,
	useFlexLayout,
	useExpanded,
	useResizeColumns,
} from "react-table";
import "./DetailedTable.css";
import Tooltip from "./form-components/Tooltip.jsx";


function Table({ columns, data, setHoveredRow, expandAll, retrieveData, limit }) {
	const openResourceTypes = sessionStorage.getItem("openUntaggedTransactionsAggregates");
	const openRows = openResourceTypes ? openResourceTypes.split(",") : [];
	let defaultExpandedRows = {};
	
	
	data.forEach((element, index) => {
		if (openRows.includes(element.service_type) || expandAll) {
			defaultExpandedRows[index] = true;
		}
	});

	const defaultColumn = React.useMemo(
		() => ({
			minWidth: 30,
			width: 150,
			maxWidth: 800,
		}),
		[]
	);

	const { getTableProps, getTableBodyProps, headerGroups, rows, prepareRow } =
		useTable(
			{
				columns,
				data,
				defaultColumn,
                autoResetExpanded: false,
				collapseOnDataChange: false,
				initialState: { expanded: defaultExpandedRows },
			},
			useFlexLayout,
			useExpanded,
			useResizeColumns
		);


	return (
		<div {...getTableProps()} className="flex cursor-default flex-auto flex-col">
			<div className="py-2 border-b border-border pl-4 text-text-2 sticky top-0 z-50 bg-card">
				{headerGroups.map((headerGroup) => (
					<div {...headerGroup.getHeaderGroupProps()} className="tr">
						{headerGroup.headers.map((column) => (
							<div
								{...column.getHeaderProps()}
								className="th uppercase text-sm"
							>
								{column.render("Header")}
								<div
									{...column.getResizerProps()}
									className={`resizer ${column.isResizing ? "isResizing" : ""}`}
								/>
							</div>
						))}
					</div>
				))}
			</div>

			{/* <div {...getTableBodyProps()} className="flex-auto">
            <AutoSizer>
					{({ height, width }) => (
						<List
							height={height}
							itemCount={rows.length}
							itemSize={40}
							width={width}
						>
							{RenderRow}
						</List>
					)}
				</AutoSizer>
			</div> */}

			<div {...getTableBodyProps()} className="">	
				{rows.map((row, index) => {
					prepareRow(row);

					return (
						<div
							{...row.getRowProps({
							})}
							className={"tr border-b border-border hover:bg-primary-soft"}
						>
							{row.cells.map((cell) => {
								return (
									<div
										{...cell.getCellProps()}
										className="td truncate pl-1 pt-7 pb-3 text-sm"
									>
										{cell.render("Cell")}
									</div>
								);
							})}
						</div>
					);
				})}
			</div>
		</div>
	);
}

const AggregatedTable = ({
	data,
	grouping,
	toggleRow,
	openRows,
	expandAll,
	sortColumn,
	sortTable,
	retrieveData,
	limit,
	columnDefs,
}) => {
	const [, setHoveredRow] = useState(-1);

	if (data && data.length > 0) {
		return (
			<Fragment>
				<Tooltip />
				<Table
					className="flex-auto"
					columns={columnDefs}
					data={data}
                    renderRowSubComponent
                    expandedRows={false}
                    openRows={openRows}
					setHoveredRow={setHoveredRow}
					retrieveData={retrieveData}
					limit={limit}
                    expandAll={false}
					// retrieveData={({startIndex, endIndex }) => retrieveData(startIndex, endIndex)}
				/>
			</Fragment>
		);
	} else {
		return (
			<Fragment>
				<div className="ml-10 font-semibold text-3xl text-text-2"></div>
			</Fragment>
		);
	}
};

export default AggregatedTable;
